var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_9195)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4708 6.01266L15.9875 1.52933C15.8625 1.40433 15.6937 1.3335 15.5167 1.3335H6.66667C6.29792 1.3335 6 1.63141 6 2.00016V19.3335C6 19.7022 6.29792 20.0002 6.66667 20.0002H20C20.3687 20.0002 20.6667 19.7022 20.6667 19.3335V6.48558C20.6667 6.3085 20.5958 6.13766 20.4708 6.01266ZM19.1292 6.79183H15.2083V2.871L19.1292 6.79183ZM19.1667 18.5002H7.5V2.8335H13.7917V7.3335C13.7917 7.56556 13.8839 7.78812 14.0479 7.95221C14.212 8.11631 14.4346 8.2085 14.6667 8.2085H19.1667V18.5002ZM13.1667 12.8752H9.33333C9.24167 12.8752 9.16667 12.9502 9.16667 13.0418V14.0418C9.16667 14.1335 9.24167 14.2085 9.33333 14.2085H13.1667C13.2583 14.2085 13.3333 14.1335 13.3333 14.0418V13.0418C13.3333 12.9502 13.2583 12.8752 13.1667 12.8752ZM9.16667 10.2085V11.2085C9.16667 11.3002 9.24167 11.3752 9.33333 11.3752H17.3333C17.425 11.3752 17.5 11.3002 17.5 11.2085V10.2085C17.5 10.1168 17.425 10.0418 17.3333 10.0418H9.33333C9.24167 10.0418 9.16667 10.1168 9.16667 10.2085Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_9195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.f946e43544fe743f35119237ba460b76.svg";
export { ForwardRef as ReactComponent };